import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material/styles';

import { BaseDivider } from 'reservations/base/components/BaseDivider';

export type ListItemProps = {
  primaryLabel: string;
  secondaryLabel?: string;
  includeDivider?: boolean;
  onClick?: (...args: any[]) => any;
  inlineContent?: React.ReactNode;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  primaryLabelSxOverride?: SxProps;
};

export const ListItemContainer = ({ children }: React.PropsWithChildren) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
    {children}
  </Box>
);

export const ListItem = ({
  primaryLabel,
  secondaryLabel,
  onClick,
  inlineContent = null,
  includeDivider = true,
  startAdornment = null,
  endAdornment = null,
  primaryLabelSxOverride = {}
}: ListItemProps) => (
  <>
    <Box gap="16px">
      <Box
        {...(!!onClick && { onClick })}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          cursor: onClick ? 'pointer' : '',
          lineHeight: '0'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginRight: '16px',
            minWidth: '305px',
            gap: '8px'
          }}
        >
          {startAdornment}
          <Typography
            sx={{
              ...(secondaryLabel && { fontWeight: 600 }),
              ...primaryLabelSxOverride
            }}
          >
            {primaryLabel}
          </Typography>
          {inlineContent}
        </Box>
        {endAdornment ??
          (!!onClick && (
            <ChevronRightIcon
              data-testid="arrow-icon"
              sx={theme => ({ color: theme.typography.body1.color })}
            />
          ))}
      </Box>
      {secondaryLabel && <Typography>{secondaryLabel}</Typography>}
    </Box>
    {includeDivider && <BaseDivider />}
  </>
);
